import "libs/select2";
import currencySelectorInit from "../interaction/currency-selector";

const token = document.querySelector('[data-token]').getAttribute('data-token');
$.ajaxSetup({
    headers: {"X-CSRF-TOKEN": token}
});
$(function () {
    $("[data-vd-select]").select2();
    currencySelectorInit();
});

